import { render, staticRenderFns } from "./FaLightIcon.vue?vue&type=template&id=21ea83c0"
import script from "./FaLightIcon.vue?vue&type=script&lang=ts"
export * from "./FaLightIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports